<template lang='pug'>
  //-
    @file 增删改查通用组件
    @author 李小龙
    @date 2018/5/31
  .crud(:class='{"hide-paging": hidePaging}')
    .functions
      el-form(ref='selectForm' :inline='true' v-if='mySelectModel' :model='form' :rules='mySelectModel.rules')
        model-inputs(:model='mySelectModel' :form='form' :has-project-tree='hasProjectTree')
      slot
      el-button(type='primary' @click='select(1)' v-if='!hideSelect')
        i.el-icon-search
        |  查询
      slot(name='fr')
      el-button.fr(type='primary' @click='showAdd' v-if='!hideOper && btnsShown.includes("添加")')
        i.el-icon-plus
        |  添加
      el-button.fr(type='primary' @click='exportTable' v-if='hasExport && btnsShown.includes("导出")')
        i.el-icon-download
        |  导出
    el-table(:data='tableData' border='' :height='myTableHeight' @selection-change="handleSelectionChange" :span-method='spanMethod' @sort-change='sortChange' row-key="id" :tree-props="{children: 'recognitionDtoList', hasChildren: 'hasChildren'}")
      el-table-column(label="序号" type="index" width='36' v-if="hasIndex")
      el-table-column(type="selection" width="36" v-if="hasCheckbox")
      el-table-column(v-if='!attr.hideInTable' v-for='attr in myModel' :label='attr.label' :key='attr.prop' :min-width='attr.minWidth||(attr.type=="image"?100:80)' :sortable='attr.sortable')
        template(slot-scope="scope")
          .cell-content(v-if='attr.type != "parent"')
            span(v-if='attr.type!="image" && attr.type != "multi-image"' v-text='attr.formatter?attr.formatter(scope.row, attr.prop, scope.row[attr.prop]):scope.row[attr.prop]')
            span(v-if='flagObj && attr.prop == flagObj.colName && scope.row[flagObj.flagName] == 1' v-text='flagObj.text' :style='flagObj.style')
            viewer(v-if='attr.type == "image"')
              img(:src='scope.row[attr.prop]')
            viewer.multi-image(v-if='attr.type=="multi-image" && scope.row[attr.prop]!=null')
              img(v-for='src in scope.row[attr.prop].split(",")' :src='src')
            //- template(v-if='attr.type=="multi-image" && scope.row[attr.prop]!=null')
            //-   viewer.multi-image(:images='scope.row[attr.prop].split(",")')
            //-     img(v-for='src in scope.row[attr.prop].split(",")' :src='src')  v-if='!hideOper && !readonly && btnsShown.includes("编辑")'
      el-table-column(v-if='!hideOper || rowOpers || hasInfo' :fixed="isFixed" label="操作" :min-width='operWidth||"110px"')
        template(slot-scope="scope" v-if='!hideRowOper || !hideRowOper(scope.row)')
          el-button(@click="showEdit(scope.row)" size="small" type='primary'  v-if='!hideOper && !readonly && btnsShown.includes("编辑")') 编辑
          el-button(@click="showInfo(scope.row)" size="small" type='primary' v-if='hasInfo && btnsShown.includes("详细")') 详细
          //暂不考虑权限按钮字会变的情况
          el-button(v-for='(oper, $index) in rowOpers' :key='$index' size='small' :type='oper.type||"primary"' @click='oper.handler(JSON.parse(JSON.stringify(scope.row)))' v-if='(!oper.hide || !oper.hide(scope.row)) && btnsShown.includes(oper.text)') {{(typeof oper.text == 'function')?oper.text(scope.row):oper.text}}
          el-button(@click="remove(scope.row)" size="small" type='danger' v-if='!hideOper && !hideDelete && !readonly && btnsShown.includes("删除")') 删除
          //- span(v-if="scope.row.defaultRole == 1" v-text='sysRole')
    el-pagination(v-if='!hidePaging' layout='total, sizes, prev, pager, next, jumper', :total='total', @current-change='currentChange', @size-change='sizeChange', :page-sizes='[5, 10, 20, 30, 50]', :page-size='form.pageSize', :current-page='form.pageNum')
    model-form-dialog(:form='addForm' mode='insert' :model='myModel' :title='"添加"+name' :visible.sync='showAddModal' @save='insert' :width='dialogWidth')
    model-form-dialog(:form='editForm' mode='edit' :model='myModel' :title='"编辑"+name' :visible.sync='showEditModal' @save='update' :width='dialogWidth')
    model-form-dialog(v-if='hasInfo'  :form='infoForm' mode='info' :model='myModel' :title='name+"详细"' :visible.sync='showInfoModal' :width='dialogWidth' hide-save)
</template>

<script>
import allApi from '../js/apis.js'
import app from '../js/app.js'
import object from 'lodash/object'
import Model from 'crud-model-class'
import {rangeValidator} from '../js/util'
import ModelFormDialog from '../components/model-form-dialog'

export default {
  props: {
    'apiName': {}, //增删改查接口名前缀，不传时默认使用name
    'beforeSave': {}, //添加或编辑前对表单做处理
    'btnsShown': {default: () => {
      return {includes: () => true}
    }}, //有权限的按钮，不传时默认都有权限
    'defer': {}, //一进来不查询
    'delCode': {}, //remove使用code（解决后端接口不统一）
    'dialogWidth': String, //3个弹出框的宽度
    'dontFit': {}, //不自适应高度
    'form': {}, //查询表单
    'frontPaging': Boolean, //是否是前端分页
    'hasInfo': {}, //查看详细按钮
    'handleInfo': {}, //异步处理详细数据
    'handleTableData': {}, //展示前处理数据
    'hasCheckbox': {}, //表格左侧勾选框
    'hasIndex': {}, //显示列表序号
    'hasExport': {}, //导出
    'hasProjectTree': {}, //查询表单有项目选择树弹框
    'hasRangeValidator': {}, //是否有时间范围校验
    'hideSelect': {}, //隐藏查询按钮
    'hideDelete': {}, //隐藏删除按钮
    'hideOper': {}, //隐藏默认的添加、编辑、删除
    'hidePaging': {}, //隐藏分页
    'hideRowOper': {}, //隐藏某些行的操作按钮
    'model': {},
    'modelSrc': {}, //model和modelSrc二选一，都不传时根据name从model-srcs文件夹自动导入
    'name': {}, //弹框标题显示的名称
    'operWidth': {},
    'readonly': {}, //只读表格（隐藏编辑和删除按钮，但可添加）
    'removeUseDelete': {}, //使用delete进行remove而非post（解决后端接口不统一）
    'rowOpers': {}, //行内自定义操作按钮
    'selectModelSrc': {}, //查询表单模型源
    'selectPath': {}, //查询的结果在不同的路径下（解决后端接口不统一），格式：{data: 数据路径: {}, total: 总数路径}
    'spanMethod': {}, //合并单元格
    'sortChange': {
      type:Function,
      default: ()=> { //默认使用一个空函数
        return ()=>{}
      }
    }, //监听表格排序
    'flagObj': {}, //标签对象
    'isFixed': {
      default: 'right'
    }
  },
  components: {
    ModelFormDialog,
  },
  data() {
    return {
      addForm: {},
      allTableData: [], //存储上次查询的所有数据，用于前端分页
      editForm: {},
      infoForm: {},
      importedModel: null, //不传model和modelSrc时自动根据name引入model
      resizeListener: null,
      showAddModal: false,
      showEditModal: false,
      showInfoModal: false,
      tableData: [],
      total: 0,
      tableHeight: 200,
      selected: [],
      // sysRole: '系统角色', //角色管理模块，系统角色，不显示按钮
    }
  },
  computed: {
    myApiName() {
      return this.apiName || this.name
    },
    myModel() {
      return this.model || this.importedModel || (this.modelSrc?new Model(this.modelSrc):[])
    },
    mySelectModel() {
      return (this.selectModelSrc?new Model(this.selectModelSrc):null)
    },
    myTableHeight() {
      return this.dontFit?null:this.tableHeight
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener)
  },
  mounted() {
      setTimeout(() => {
          this.tableHeight = window.innerHeight - this.$el.offsetTop;
          var parentElement = this.$el.parentElement.parentElement.parentElement.className.split(' ')[0];
          if(parentElement == 'eltabs'){
            this.tableHeight = window.innerHeight - this.$el.offsetTop-321;
          }
      },100)
    if (!this.model && !this.modelSrc) import('../model-srcs/'+this.name).then(d => {
      this.importedModel = new Model(d.default)
    })
    if (!this.dontFit) {
      this.getHeight()
      this.resizeListener = window.addEventListener('resize', this.getHeight)
      setTimeout(this.getHeight, 200)
    }
    if (this.defer) return
    this.select()
  },
  methods: {
    //自适应屏幕大小
    getHeight() {
      if (
        !document.querySelector('main') ||

        !document.querySelector('.functions')
      )
        return
      var tabs = document.querySelector('.el-tabs')
      var extra = document.querySelector('pre.extra')
      //解决el-table不能快速改变height的bug
      this.$nextTick(() => {
        this.tableHeight =
          document.querySelector('main').clientHeight -
          (document.querySelector('.page-title')? document.querySelector('.page-title').offsetHeight:0) -
          document.querySelector('.functions').offsetHeight -
          (this.hidePaging?30:62) -
          (tabs ? tabs.offsetHeight : 0) -
          (extra ? (extra.offsetHeight-10) : 0)
        /*
        if(document.querySelector('.el-tabs__header')){
           var parentElement =  document.querySelector('.el-tabs__header').parentElement.className.split(' ')[0];
        }
        console.log(window.innerHeight)
        console.log(this.$el.offsetTop)

        if(parentElement == 'eltabs'){
          this.tableHeight = window.innerHeight - this.$el.offsetTop-321;
        }
        */

      })
    },
    currentChange(pageNum) {
      this.form.pageNum = pageNum
      var end = this.form.pageSize * this.form.pageNum
      if (this.frontPaging) {
        this.tableData = []
        this.$nextTick(() => {
          this.tableData = this.allTableData.slice(end-this.form.pageSize, end)
        })
      } else this.select()
    },
    exportTable() {
      var form = document.getElementById('export-form') || document.createElement('form')
      document.body.appendChild(form)
      form.outerHTML = `<form id='export-form' action='${allApi[this.myApiName + 'Export']}' style='display:none' method='get'>
        <input type='text' name='token' value='${sessionStorage.token}'>
        ${this.getParamsInputs(this.form)}
      </form>`
      document.getElementById('export-form').submit() //更改outerHTML后form不再指向是新生成的form，需重新获取
    },
    /** 将参数对象转换成一串input */
    getParamsInputs(params) {
      var result = ''
      for (var i in params) {
        result += `<input type='text' name='${i}' value='${params[i]==null?'':params[i]}'>`
      }
      return result
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    insert() {
      if (this.beforeSave) {
        this.beforeSave(this.addForm)
      }
      app
        .post(this.myApiName + 'Insert', this.addForm, '.add .el-dialog')
        .then(d => {
          this.$message.success(d.message || d.responseMessage)
          this.showAddModal = false
          this.select()
          this.addForm = {}
        })
    },
    remove(row, msg, customKey) {
      let para = { [customKey || 'id']: row.id }
      if (this.delCode) para = { code: row.code }
      this.$confirm(msg || '是否确定删除？', '提示', {
            type: 'warning'
          })
        .then(() => {
          var aj = this.removeUseDelete ? app.delete : app.post
          aj(this.myApiName + 'Delete', para, 'main').then(d => {
            this.$message.success(d.message || d.responseMessage)
            this.select()
          })
        })
        .catch(e => {})
    },
    select(page) {
      console.log(page)
      let tmp = this.form.pageNum
      if (this.hasRangeValidator) {
        if (!rangeValidator(this.form)) return
      }
      if (this.hasProjectTree && this.form.orgIds == '' && this.form.projectIds == '') {
        this.$message.warning('请选择项目')
        return
      }
      var p = this.$refs.selectForm?this.$refs.selectForm.validate():Promise.resolve()
      p.then(() => {
        this.$emit('select-start')
        if (page != null) {
          this.form.pageNum = page//在判断加了else避免重新赋值
        }else{
          this.form.pageNum=tmp;
        }
        this.tableData = []
        if(this.form.name!=""&&typeof(this.form.name)!="undefined"){ //如果是搜索姓名时，将pageNum设为1。否则在除第1页外的其它任何页面都搜不到任何内容
            this.form.pageNum=1;
        }
        var aj = app.get
        aj(this.myApiName + 'Select', this.form, this.$el).then(d => {
          console.log(d)
          this.$emit('getReqData', d)
          var path = object.get(this, 'selectPath.data') || 'data'
          if (this.handleTableData)
            object.set(d, path, this.handleTableData(object.get(d, path)))
          this.allTableData = object.get(d, path)
          if (this.frontPaging) this.tableData = this.allTableData.slice(0, this.form.pageSize)
          else this.tableData = this.allTableData
          this.total = object.get(
            d,
            object.get(this, 'selectPath.total') || 'total'
          )
          // if(this.total!=0&&this.tableData.length==0){
          //   this.form.pageNum = this.form.pageNum -1
          //   this.select()
          // }
        })
      })
    },
    sizeChange(size) {
      this.form.pageSize = size
      this.select()
    },
    showAdd() {
      var addForm = {}
      for (let m of this.myModel) {
        if (m.default != null) {
          addForm[m.prop] = m.default
        }
      }
      this.addForm = addForm
      this.showAddModal = true
    },
    showEdit(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.showEditModal = true
    },
    showInfo(row) {
      if (this.handleInfo) {
        this.infoForm = {}
        this.handleInfo(row).then(res => {
          this.infoForm = res
        })
      } else {
        this.infoForm = row
      }
      this.showInfoModal = true
    },
    update() {
      if (this.beforeSave) {
        this.beforeSave(this.editForm)
      }
      var aj = app.post
      aj(this.myApiName + 'Update', this.editForm, '.edit .el-dialog').then(
        d => {
          this.$message.success(d.message || d.responseMessage)
          this.showEditModal = false
          this.select()
          this.editForm = {}
        }
      )
    },
  }
}
</script>

<style scoped>
 /deep/ .el-table .el-table__row--level-1{
  background-color: #F7F7F7;
}
/deep/ .el-table .el-table__expand-icon{
  float: left;
}
/deep/ .cell-content,/deep/ .el-table__indent{
  display: inline-block;
  padding-left: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/components/crud.vue